import { render } from "./VehicleSide.vue?vue&type=template&id=41bf6ac4"
import script from "./VehicleSide.vue?vue&type=script&lang=js"
export * from "./VehicleSide.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__